/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Manager} from '../../core/_models'
import {useListView} from '../../core/ListViewProvider'

type Props = {
  manager: Manager
  display: boolean
}

const ManagerInfoCell: FC<Props> = ({manager, display = false}) => {
  const {setItemIdForUpdate} = useListView()
  const openEditModal = () => {
    setItemIdForUpdate(manager.id)
  }

  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        <a style={{display:(!display) ? 'none' : ''}}
          onClick={openEditModal}
          role='button'
          className='text-gray-800 text-hover-primary mb-1 pointer-cli'
        >
          {manager.name}
        </a>
        <span style={{display:(display) ? 'none' : ''}}
        >
          {manager.name}
        </span>
      </div>
    </div>
  )
}

export {ManagerInfoCell}
